import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heart } from 'lucide-react';

const DonationTabs = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const containerStyle = {
    borderRadius: '0.5rem',
    overflow: 'hidden',
    margin: '1.5rem 0',
    alignContent: 'center'
  };

  return (
    <div className="panels-section" style={containerStyle}>
      
      <div
        type="button"
        className={`panel ${activeTab === 'weekly' ? 'selected' : ''}`}
        onClick={() => setActiveTab('weekly')}
      >
        {/* {activeTab === 'weekly' && <Heart style={heartStyle} />} */}
        <h3>{t('autoAjr.weeklyFridayJummah')}</h3>
      </div>
      <div
        type="button"
        className={`panel ${activeTab === 'once' ? 'selected' : ''}`}
        onClick={() => setActiveTab('once')}
      >
        <h3>{t('autoAjr.giveOnce')}</h3>
      </div>
    </div>
  );
};

export default DonationTabs;